import styled from 'styled-components';

export const ModalTitle = styled.h1`
    margin-top: 0;
`;
